// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/JF-Flat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/basic/header.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/search.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --dark--bg: rgb(28, 27, 27);
  --dark-color: whitesmoke;
  --dark-code: black;

  --light--bg: white;
  --white--bg: rgb(237, 237, 237);; 
}


.card-x {
  display: inline-block;
  width: 20%;
  margin: 5px;
  color: whitesmoke;
  background-color: #363333;
  padding: 20px;
  text-align: center;
}

@font-face {
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-family: JF-Flat;
}


.number{
  /* font-family: 'RubikDoodleShadow'; */
  font-size: 20px;
  font-weight: bolder;
}

*{
  padding: 0;
  margin: 0;
}
body{
  font-family: 'Cairo', 'JF-Flat',sans-serif;
  background-color: var(--primary-page--bg);


  --primary-page--bg: #1b1b1b;
  --primary-text-color: whitesmoke;

  --shadow-color: whitesmoke;
  --frame-box-color: whitesmoke;
  color: var(--primary-text-color);

  --bg-card-color: #252525;
}
body.light {
  --primary-page--bg: rgb(237, 237, 237);
  --primary-text-color: #1b1b1b;

  --shadow-color: gray;
  --bg-card-color: whitesmoke;

}

a {
  color: var(--primary-text-color);
}
iframe {
  width: 90%;
  height: 260px;
  
}
img {
  width: 90%;
  /* height: 260px; */
  pointer-events: none;
}
.container{

}
/* Header  CONST */
.header {
  height: 100px;
  padding: 30px;
  color: white;
  background: rgb(28, 27, 27);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat:no-repeat;
  background-position: center;

}


/* START Navbar css settings  CONST*/
.navbar {
  background: rgb(28, 27, 27);
  min-height: 30px;
  padding: 20px;
  text-align:center;
  box-shadow: 10px 10px 10px grey; /* box shadow: [right] [down] [shadow] [color]*/
  overflow: hidden;
  transition: width 2s, height 4s;

}


.navbar .selecter li{
  list-style-type: none;
  display: inline;
  padding: 10px;
  margin: 10px;
  line-height: auto;
  color: white;

}
.navbar .selecter li a {
  color: #e8e3e3;
  text-decoration: none;
  font-size: 15px;
}
.navbar .selecter li a:hover {
  text-decoration: inherit;
}
.navbar .selecter li:hover {
  background-color: #363333;
  border-radius: 5px;
}

/* button resposive */

.navbar .icon {
  display: none;
}
.navbar .selecter .Name-tag{
  display: none;
}

/* END Navbar css settings */
/* Navbar responsive */
@media screen and (max-width: 800px){
  .navbar .selecter li{
    display: none;
  }
  .navbar .resposive li{
    display: block;
  }
  .navbar .icon {
    overflow: auto;
    display: block;
    float: right;
    color: white;
    padding: 5px;
    border: 2px solid white;
    font-size: 15px;
    width: 10%;
  }
  .navbar .selecter .Name-tag{
    display: block;
    float: left;

  }
  .navbar .selecter .Name-tag::before{
    content: "IBRAHIM";
    color: white;

  }

}

.content {
  min-height: 800px;
  overflow: hidden;
  margin: 10px;
}

/* The cards design */
.card {
  margin-top: 10px;
  background-color: var(--primary-page--bg);
  margin-bottom: 10px;
  color: var(--primary-text-color);
  box-shadow: 2px 2px 5px gray; /* box shadow: [right] [down] [shadow] [color]*/
  border-radius: 5px;

}
.card-body img {
  object-fit: cover;
}
.card-comment{
    font-size: 15px;
    color: white;
    background: #2e2c2c;
    width: 70%;
    border-radius: 30px;
    border: 2px solid #666;
    padding: 10px;
    margin: 15px;
    direction: rtl;


}
.card .card-header {
  border-radius: 5px;
  overflow: hidden;
  color: white;
  background: #2e2e2e;
  /* box-shadow: 0px 2px 3px grey; */
  text-align: left;
  padding: 10px;
}
.card .card-header p:first-child::before{
  content: "➔ ";
}
.card-body {
  padding: 10px;
  text-align: center;
  overflow: hidden;

}


/* The right side */
.panel-right{
  width: 20%;
  float: right;
}
/* The Left side */
.panel-left {
  width: 20%;
  float: left;
}
/* The center side */
.panel-center {
  width: 50%;
  padding: 10px;
  display: inline-block;
  margin: auto;
  padding-left: 5%;
}

/* resposive mobile phone */
@media screen and (max-width: 800px){
    .panel-right, .panel-left, .panel-center{
      width: 90%;
      /* color: black; */
      float: none;
      margin: auto;
      display: inline-block;
      padding: 5%;
    }

}

/* The footer down the page */
.footer {
  background: rgb(28, 27, 27);
  color:  #ededed;
  min-height: 130px;
  overflow: hidden;
  /* padding: 10px; */
  /* box-shadow: 10px 10px 50px grey; */
  /* background-image: url('../img/basic/footer.jpg'); */
  background-repeat:no-repeat;
  background-position: center;

}

/*footer level colors */
.f-level3 {
  background-color: #1f1e1e;
  padding: 10px;
}
.f-level2 {
  background-color: #242323;
  padding: 10px;
}
.f-level1 {
  background-color: #303030;
  padding: 10px;
}
/*footer level colors */

.footer ul {
  list-style-type: decimal;
  list-style-position:  inside;
}
.copyright {
  text-align: center;
}
.copyright::before {
  content: "© ";
}
/* The center side */
.info-center {
  text-align: center;
  width: 20%;
  margin: auto;
  padding: 10px;
}

/* The right side */
.info-right{
  width: 20%;
  float: right;
  padding: 10px;
  margin-right: 10px;
}

/* The Left side */
.info-left {
  width: 20%;
  padding:10px;
  float: left;
  margin-left: 30px;
}

.info-center a, .info-right a, .info-left a {
  color: white;
}
.info-center a:hover, .info-right a:hover, .info-left a:hover {
  color: #d7dbd8;
}

/* info resposive */
@media screen and (max-width: 800px){
  /* The center side */
  .info-center, .info-right, .info-left {
    text-align: center;
    width: 90%;
    margin: auto;
    padding: 20px;
  }

  
}

@media screen and (max-width: 1400px){
  .card-x {
    display: block;
    width: 50%;
    margin: auto;
  }
}

/* Text settings */
.center {
  text-align: center;
  margin: auto;
}
.left, .ar {
  text-align: left;
  float: left;
}
.right, .en {
  text-align: right;
  float: right;
}

/* btn settings */

.form {
  padding: 10px;
  color: #d7dbd8;
  background: rgb(28, 27, 27);
  width: 50%;
  border: 1px;
  border-radius: 0px 20px 20px 0px;
}

.btn {
  min-width: 5%;
  border: 1px;
  border-radius: 20px;
  padding: 10px;
  color: #d7dbd8;
  background: rgb(28, 27, 27);
}

.btn-search{
  width: 5%;
  border: 1px;
  border-radius: 20px 0px 0px 20px;
  padding: 10px;
  color: #d7dbd8;
  background: rgb(28, 27, 27);
}

/* search results */

#showSearch {
  overflow: hidden;
  background: rgb(209, 200, 200);
  text-align: left;
  text-decoration: underline;
  width: 50%;
  margin: auto;
  padding: 10px;
}


/*loading */

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid black;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.react-pdf__Page__canvas {
  margin: 0 auto;
  width: 95% !important;
  height: 100% !important;
}


/* side nav blogs */


.side-nav  {
  text-align: left;
  background-color: #252525;
  color: var(--primary-text-color);
  background-color: var(--bg-card-color);
  font-weight: bold;
  /* height: 1200px; */
  width: 90%;
  border-radius: 20px;
  padding: 20px;
  margin-top: 50px;
  
}

.sub-side li {
  margin: 5px;
  list-style-position: inside;
  list-style-type: decimal;
}
.sub-side li:hover {
  background-color: #363333;
}

/* sub with details */
details ol {
  counter-reset: item;
}
details li {
  display: block;

}


details li:before {
  content: counters(item, ".") " ";
  counter-increment: item
}



/* end sub with details */



details > summary {
  list-style: none;
}

details[open] summary:after {
  content: " >";
}



/* input buttons styles */
input {
  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  background-color: var(--primary-page--bg);
  color: var(--primary-text-color);
  /* background-image: url('searchicon.png'); */
  padding: 12px 20px 12px 40px;
  margin: 10px;
}

input[name="search"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: 10px 10px; 
  background-repeat: no-repeat;
}

textarea {
  width: 100%;
  height: 150px;
  padding: 12px 20px;
  margin: 10px;

  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  color: var(--primary-text-color);
  background-color: var(--primary-page--bg);
  resize: none;
}

button {
  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: var(--primary-page--bg);
  color: var(--primary-text-color);
  /* background-image: url('searchicon.png'); */
  background-position: 10px 10px; 
  background-repeat: no-repeat;
  padding: 12px 20px 12px 40px;
  margin: 10px;
  cursor: pointer;
}

button:hover {
  background-color: gray;
}

/* .inputEnter {
  background-color: var(--bg-card-color);
  color: var(--primary-text-color);

  padding: 20px;
  margin: 10px;
  border-width: 1px;
  width: 50%;

} */

.blog-content {
  all: revert; /* Resets inherited styles but keeps inline styles from the HTML */
}

.blog-content * {
  all: revert; /* Resets inherited styles but keeps inline styles from the HTML */
  display: revert; /* Revert the display property to default for each element */
}



/* Add any specific styles for .blog-content if needed */
.blog-content p {
  margin: 0;
  padding: 0;
}

ql-align-center {
  text-align: center;
}

.ql-align-left {
  text-align: left;
}

.ql-align-right {
  text-align: right;
  list-style-position: inside;
  direction: rtl;
}`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;;EAElB,kBAAkB;EAClB,+BAA+B;AACjC;;;AAGA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,4CAAsC;EACtC,oBAAoB;AACtB;;;AAGA;EACE,sCAAsC;EACtC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,0CAA0C;EAC1C,yCAAyC;;;EAGzC,2BAA2B;EAC3B,gCAAgC;;EAEhC,0BAA0B;EAC1B,6BAA6B;EAC7B,gCAAgC;;EAEhC,wBAAwB;AAC1B;AACA;EACE,sCAAsC;EACtC,6BAA6B;;EAE7B,oBAAoB;EACpB,2BAA2B;;AAE7B;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,aAAa;;AAEf;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;AAEA;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,yDAAgD;EAChD,2BAA2B;EAC3B,2BAA2B;;AAE7B;;;AAGA,oCAAoC;AACpC;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,+BAA+B,EAAE,+CAA+C;EAChF,gBAAgB;EAChB,+BAA+B;;AAEjC;;;AAGA;EACE,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,YAAY;;AAEd;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,qBAAqB;;AAErB;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,UAAU;EACZ;EACA;IACE,cAAc;IACd,WAAW;;EAEb;EACA;IACE,kBAAkB;IAClB,YAAY;;EAEd;;AAEF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B,EAAE,+CAA+C;EAC7E,kBAAkB;;AAEpB;AACA;EACE,iBAAiB;AACnB;AACA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,cAAc;;;AAGlB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;;AAElB;;;AAGA,mBAAmB;AACnB;EACE,UAAU;EACV,YAAY;AACd;AACA,kBAAkB;AAClB;EACE,UAAU;EACV,WAAW;AACb;AACA,oBAAoB;AACpB;EACE,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;IACI;MACE,UAAU;MACV,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,qBAAqB;MACrB,WAAW;IACb;;AAEJ;;AAEA,6BAA6B;AAC7B;EACE,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,sDAAsD;EACtD,2BAA2B;EAC3B,2BAA2B;;AAE7B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,aAAa;AACf;AACA,uBAAuB;;AAEvB;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;EACf;;;AAGF;;AAEA;EACE;IACE,cAAc;IACd,UAAU;IACV,YAAY;EACd;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,2BAA2B;AAC7B;;AAEA,mBAAmB;;AAEnB;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;;AAGA,WAAW;;AAEX;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,8DAA8D;AAChE;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;;AAGA,mBAAmB;;;AAGnB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,sCAAsC;EACtC,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,gBAAgB;;AAElB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;;AAEhB;;;AAGA;EACE,gCAAgC;EAChC;AACF;;;;AAIA,yBAAyB;;;;AAIzB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;;;AAIA,yBAAyB;AACzB;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,gCAAgC;EAChC,6CAA6C;EAC7C,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,yDAA0C;EAC1C,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,YAAY;;EAEZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,gCAAgC;EAChC,6CAA6C;EAC7C,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,WAAW,EAAE,kEAAkE;AACjF;;AAEA;EACE,WAAW,EAAE,kEAAkE;EAC/E,eAAe,EAAE,4DAA4D;AAC/E;;;;AAIA,wDAAwD;AACxD;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB","sourcesContent":[":root {\r\n  --dark--bg: rgb(28, 27, 27);\r\n  --dark-color: whitesmoke;\r\n  --dark-code: black;\r\n\r\n  --light--bg: white;\r\n  --white--bg: rgb(237, 237, 237);; \r\n}\r\n\r\n\r\n.card-x {\r\n  display: inline-block;\r\n  width: 20%;\r\n  margin: 5px;\r\n  color: whitesmoke;\r\n  background-color: #363333;\r\n  padding: 20px;\r\n  text-align: center;\r\n}\r\n\r\n@font-face {\r\n  src: url(../fonts/JF-Flat-Regular.ttf);\r\n  font-family: JF-Flat;\r\n}\r\n\r\n\r\n.number{\r\n  /* font-family: 'RubikDoodleShadow'; */\r\n  font-size: 20px;\r\n  font-weight: bolder;\r\n}\r\n\r\n*{\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\nbody{\r\n  font-family: 'Cairo', 'JF-Flat',sans-serif;\r\n  background-color: var(--primary-page--bg);\r\n\r\n\r\n  --primary-page--bg: #1b1b1b;\r\n  --primary-text-color: whitesmoke;\r\n\r\n  --shadow-color: whitesmoke;\r\n  --frame-box-color: whitesmoke;\r\n  color: var(--primary-text-color);\r\n\r\n  --bg-card-color: #252525;\r\n}\r\nbody.light {\r\n  --primary-page--bg: rgb(237, 237, 237);\r\n  --primary-text-color: #1b1b1b;\r\n\r\n  --shadow-color: gray;\r\n  --bg-card-color: whitesmoke;\r\n\r\n}\r\n\r\na {\r\n  color: var(--primary-text-color);\r\n}\r\niframe {\r\n  width: 90%;\r\n  height: 260px;\r\n  \r\n}\r\nimg {\r\n  width: 90%;\r\n  /* height: 260px; */\r\n  pointer-events: none;\r\n}\r\n.container{\r\n\r\n}\r\n/* Header  CONST */\r\n.header {\r\n  height: 100px;\r\n  padding: 30px;\r\n  color: white;\r\n  background: rgb(28, 27, 27);\r\n  background-image: url('../img/basic/header.jpg');\r\n  background-repeat:no-repeat;\r\n  background-position: center;\r\n\r\n}\r\n\r\n\r\n/* START Navbar css settings  CONST*/\r\n.navbar {\r\n  background: rgb(28, 27, 27);\r\n  min-height: 30px;\r\n  padding: 20px;\r\n  text-align:center;\r\n  box-shadow: 10px 10px 10px grey; /* box shadow: [right] [down] [shadow] [color]*/\r\n  overflow: hidden;\r\n  transition: width 2s, height 4s;\r\n\r\n}\r\n\r\n\r\n.navbar .selecter li{\r\n  list-style-type: none;\r\n  display: inline;\r\n  padding: 10px;\r\n  margin: 10px;\r\n  line-height: auto;\r\n  color: white;\r\n\r\n}\r\n.navbar .selecter li a {\r\n  color: #e8e3e3;\r\n  text-decoration: none;\r\n  font-size: 15px;\r\n}\r\n.navbar .selecter li a:hover {\r\n  text-decoration: inherit;\r\n}\r\n.navbar .selecter li:hover {\r\n  background-color: #363333;\r\n  border-radius: 5px;\r\n}\r\n\r\n/* button resposive */\r\n\r\n.navbar .icon {\r\n  display: none;\r\n}\r\n.navbar .selecter .Name-tag{\r\n  display: none;\r\n}\r\n\r\n/* END Navbar css settings */\r\n/* Navbar responsive */\r\n@media screen and (max-width: 800px){\r\n  .navbar .selecter li{\r\n    display: none;\r\n  }\r\n  .navbar .resposive li{\r\n    display: block;\r\n  }\r\n  .navbar .icon {\r\n    overflow: auto;\r\n    display: block;\r\n    float: right;\r\n    color: white;\r\n    padding: 5px;\r\n    border: 2px solid white;\r\n    font-size: 15px;\r\n    width: 10%;\r\n  }\r\n  .navbar .selecter .Name-tag{\r\n    display: block;\r\n    float: left;\r\n\r\n  }\r\n  .navbar .selecter .Name-tag::before{\r\n    content: \"IBRAHIM\";\r\n    color: white;\r\n\r\n  }\r\n\r\n}\r\n\r\n.content {\r\n  min-height: 800px;\r\n  overflow: hidden;\r\n  margin: 10px;\r\n}\r\n\r\n/* The cards design */\r\n.card {\r\n  margin-top: 10px;\r\n  background-color: var(--primary-page--bg);\r\n  margin-bottom: 10px;\r\n  color: var(--primary-text-color);\r\n  box-shadow: 2px 2px 5px gray; /* box shadow: [right] [down] [shadow] [color]*/\r\n  border-radius: 5px;\r\n\r\n}\r\n.card-body img {\r\n  object-fit: cover;\r\n}\r\n.card-comment{\r\n    font-size: 15px;\r\n    color: white;\r\n    background: #2e2c2c;\r\n    width: 70%;\r\n    border-radius: 30px;\r\n    border: 2px solid #666;\r\n    padding: 10px;\r\n    margin: 15px;\r\n    direction: rtl;\r\n\r\n\r\n}\r\n.card .card-header {\r\n  border-radius: 5px;\r\n  overflow: hidden;\r\n  color: white;\r\n  background: #2e2e2e;\r\n  /* box-shadow: 0px 2px 3px grey; */\r\n  text-align: left;\r\n  padding: 10px;\r\n}\r\n.card .card-header p:first-child::before{\r\n  content: \"➔ \";\r\n}\r\n.card-body {\r\n  padding: 10px;\r\n  text-align: center;\r\n  overflow: hidden;\r\n\r\n}\r\n\r\n\r\n/* The right side */\r\n.panel-right{\r\n  width: 20%;\r\n  float: right;\r\n}\r\n/* The Left side */\r\n.panel-left {\r\n  width: 20%;\r\n  float: left;\r\n}\r\n/* The center side */\r\n.panel-center {\r\n  width: 50%;\r\n  padding: 10px;\r\n  display: inline-block;\r\n  margin: auto;\r\n  padding-left: 5%;\r\n}\r\n\r\n/* resposive mobile phone */\r\n@media screen and (max-width: 800px){\r\n    .panel-right, .panel-left, .panel-center{\r\n      width: 90%;\r\n      /* color: black; */\r\n      float: none;\r\n      margin: auto;\r\n      display: inline-block;\r\n      padding: 5%;\r\n    }\r\n\r\n}\r\n\r\n/* The footer down the page */\r\n.footer {\r\n  background: rgb(28, 27, 27);\r\n  color:  #ededed;\r\n  min-height: 130px;\r\n  overflow: hidden;\r\n  /* padding: 10px; */\r\n  /* box-shadow: 10px 10px 50px grey; */\r\n  /* background-image: url('../img/basic/footer.jpg'); */\r\n  background-repeat:no-repeat;\r\n  background-position: center;\r\n\r\n}\r\n\r\n/*footer level colors */\r\n.f-level3 {\r\n  background-color: #1f1e1e;\r\n  padding: 10px;\r\n}\r\n.f-level2 {\r\n  background-color: #242323;\r\n  padding: 10px;\r\n}\r\n.f-level1 {\r\n  background-color: #303030;\r\n  padding: 10px;\r\n}\r\n/*footer level colors */\r\n\r\n.footer ul {\r\n  list-style-type: decimal;\r\n  list-style-position:  inside;\r\n}\r\n.copyright {\r\n  text-align: center;\r\n}\r\n.copyright::before {\r\n  content: \"© \";\r\n}\r\n/* The center side */\r\n.info-center {\r\n  text-align: center;\r\n  width: 20%;\r\n  margin: auto;\r\n  padding: 10px;\r\n}\r\n\r\n/* The right side */\r\n.info-right{\r\n  width: 20%;\r\n  float: right;\r\n  padding: 10px;\r\n  margin-right: 10px;\r\n}\r\n\r\n/* The Left side */\r\n.info-left {\r\n  width: 20%;\r\n  padding:10px;\r\n  float: left;\r\n  margin-left: 30px;\r\n}\r\n\r\n.info-center a, .info-right a, .info-left a {\r\n  color: white;\r\n}\r\n.info-center a:hover, .info-right a:hover, .info-left a:hover {\r\n  color: #d7dbd8;\r\n}\r\n\r\n/* info resposive */\r\n@media screen and (max-width: 800px){\r\n  /* The center side */\r\n  .info-center, .info-right, .info-left {\r\n    text-align: center;\r\n    width: 90%;\r\n    margin: auto;\r\n    padding: 20px;\r\n  }\r\n\r\n  \r\n}\r\n\r\n@media screen and (max-width: 1400px){\r\n  .card-x {\r\n    display: block;\r\n    width: 50%;\r\n    margin: auto;\r\n  }\r\n}\r\n\r\n/* Text settings */\r\n.center {\r\n  text-align: center;\r\n  margin: auto;\r\n}\r\n.left, .ar {\r\n  text-align: left;\r\n  float: left;\r\n}\r\n.right, .en {\r\n  text-align: right;\r\n  float: right;\r\n}\r\n\r\n/* btn settings */\r\n\r\n.form {\r\n  padding: 10px;\r\n  color: #d7dbd8;\r\n  background: rgb(28, 27, 27);\r\n  width: 50%;\r\n  border: 1px;\r\n  border-radius: 0px 20px 20px 0px;\r\n}\r\n\r\n.btn {\r\n  min-width: 5%;\r\n  border: 1px;\r\n  border-radius: 20px;\r\n  padding: 10px;\r\n  color: #d7dbd8;\r\n  background: rgb(28, 27, 27);\r\n}\r\n\r\n.btn-search{\r\n  width: 5%;\r\n  border: 1px;\r\n  border-radius: 20px 0px 0px 20px;\r\n  padding: 10px;\r\n  color: #d7dbd8;\r\n  background: rgb(28, 27, 27);\r\n}\r\n\r\n/* search results */\r\n\r\n#showSearch {\r\n  overflow: hidden;\r\n  background: rgb(209, 200, 200);\r\n  text-align: left;\r\n  text-decoration: underline;\r\n  width: 50%;\r\n  margin: auto;\r\n  padding: 10px;\r\n}\r\n\r\n\r\n/*loading */\r\n\r\n.lds-ripple {\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 80px;\r\n  height: 80px;\r\n}\r\n.lds-ripple div {\r\n  position: absolute;\r\n  border: 4px solid black;\r\n  opacity: 1;\r\n  border-radius: 50%;\r\n  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\r\n}\r\n.lds-ripple div:nth-child(2) {\r\n  animation-delay: -0.5s;\r\n}\r\n@keyframes lds-ripple {\r\n  0% {\r\n    top: 36px;\r\n    left: 36px;\r\n    width: 0;\r\n    height: 0;\r\n    opacity: 0;\r\n  }\r\n  4.9% {\r\n    top: 36px;\r\n    left: 36px;\r\n    width: 0;\r\n    height: 0;\r\n    opacity: 0;\r\n  }\r\n  5% {\r\n    top: 36px;\r\n    left: 36px;\r\n    width: 0;\r\n    height: 0;\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    top: 0px;\r\n    left: 0px;\r\n    width: 72px;\r\n    height: 72px;\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.react-pdf__Page__canvas {\r\n  margin: 0 auto;\r\n  width: 95% !important;\r\n  height: 100% !important;\r\n}\r\n\r\n\r\n/* side nav blogs */\r\n\r\n\r\n.side-nav  {\r\n  text-align: left;\r\n  background-color: #252525;\r\n  color: var(--primary-text-color);\r\n  background-color: var(--bg-card-color);\r\n  font-weight: bold;\r\n  /* height: 1200px; */\r\n  width: 90%;\r\n  border-radius: 20px;\r\n  padding: 20px;\r\n  margin-top: 50px;\r\n  \r\n}\r\n\r\n.sub-side li {\r\n  margin: 5px;\r\n  list-style-position: inside;\r\n  list-style-type: decimal;\r\n}\r\n.sub-side li:hover {\r\n  background-color: #363333;\r\n}\r\n\r\n/* sub with details */\r\ndetails ol {\r\n  counter-reset: item;\r\n}\r\ndetails li {\r\n  display: block;\r\n\r\n}\r\n\r\n\r\ndetails li:before {\r\n  content: counters(item, \".\") \" \";\r\n  counter-increment: item\r\n}\r\n\r\n\r\n\r\n/* end sub with details */\r\n\r\n\r\n\r\ndetails > summary {\r\n  list-style: none;\r\n}\r\n\r\ndetails[open] summary:after {\r\n  content: \" >\";\r\n}\r\n\r\n\r\n\r\n/* input buttons styles */\r\ninput {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  border: 2px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  background-color: var(--primary-page--bg);\r\n  color: var(--primary-text-color);\r\n  /* background-image: url('searchicon.png'); */\r\n  padding: 12px 20px 12px 40px;\r\n  margin: 10px;\r\n}\r\n\r\ninput[name=\"search\"] {\r\n  background-image: url('../img/search.png');\r\n  background-position: 10px 10px; \r\n  background-repeat: no-repeat;\r\n}\r\n\r\ntextarea {\r\n  width: 100%;\r\n  height: 150px;\r\n  padding: 12px 20px;\r\n  margin: 10px;\r\n\r\n  box-sizing: border-box;\r\n  border: 2px solid #ccc;\r\n  border-radius: 4px;\r\n  color: var(--primary-text-color);\r\n  background-color: var(--primary-page--bg);\r\n  resize: none;\r\n}\r\n\r\nbutton {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  border: 2px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n  background-color: var(--primary-page--bg);\r\n  color: var(--primary-text-color);\r\n  /* background-image: url('searchicon.png'); */\r\n  background-position: 10px 10px; \r\n  background-repeat: no-repeat;\r\n  padding: 12px 20px 12px 40px;\r\n  margin: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\nbutton:hover {\r\n  background-color: gray;\r\n}\r\n\r\n/* .inputEnter {\r\n  background-color: var(--bg-card-color);\r\n  color: var(--primary-text-color);\r\n\r\n  padding: 20px;\r\n  margin: 10px;\r\n  border-width: 1px;\r\n  width: 50%;\r\n\r\n} */\r\n\r\n.blog-content {\r\n  all: revert; /* Resets inherited styles but keeps inline styles from the HTML */\r\n}\r\n\r\n.blog-content * {\r\n  all: revert; /* Resets inherited styles but keeps inline styles from the HTML */\r\n  display: revert; /* Revert the display property to default for each element */\r\n}\r\n\r\n\r\n\r\n/* Add any specific styles for .blog-content if needed */\r\n.blog-content p {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nql-align-center {\r\n  text-align: center;\r\n}\r\n\r\n.ql-align-left {\r\n  text-align: left;\r\n}\r\n\r\n.ql-align-right {\r\n  text-align: right;\r\n  list-style-position: inside;\r\n  direction: rtl;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
